import Form from 'components/Profile/Insurance/Form';

const Insurance = () => <Form />;

export default Insurance;
